import { motion } from "framer-motion";
import { Reveal } from "./anim";
import { SERVICES, STATS } from "./data";

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-36"
  >
    <div className="grid gap-6 md:grid-cols-2 md:items-end">
      <Reveal>
        <p className="mb-4 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[hsl(var(--muted))]">
          <span className="h-px w-8 bg-[hsl(var(--primary))]" /> What we do
        </p>
        <h2 className="font-head text-4xl font-semibold leading-[1.02] sm:text-5xl lg:text-6xl">
          One studio.<br />
          Every creative <span className="italic text-[hsl(var(--primary))]">discipline.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="max-w-md text-base text-[hsl(var(--muted))] md:ml-auto md:text-right">
          We blend strategy, design, film and technology under one roof — so your brand stays consistent, premium and unmistakably yours across every touchpoint.
        </p>
      </Reveal>
    </div>

    <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {SERVICES.map((s, i) => {
        const Icon = s.icon;
        return (
          <Reveal key={s.title} delay={(i % 4) * 0.08}>
            <motion.div
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              data-testid={`service-card-${i}`}
              className="group h-full rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] p-7 transition-colors duration-500 hover:border-[hsl(var(--primary)/0.5)]"
            >
              <div className="mb-14 flex h-12 w-12 items-center justify-center rounded-xl bg-[hsl(var(--primary)/0.12)] text-[hsl(var(--primary))] transition-colors duration-500 group-hover:bg-[hsl(var(--primary))] group-hover:text-[hsl(var(--primary-fg))]">
                <Icon size={22} />
              </div>
              <h3 className="mb-2 font-head text-xl font-semibold">{s.title}</h3>
              <p className="text-sm leading-relaxed text-[hsl(var(--muted))]">{s.desc}</p>
            </motion.div>
          </Reveal>
        );
      })}
    </div>

    <div className="mt-16 grid grid-cols-2 gap-6 border-t border-[hsl(var(--border))] pt-12 md:grid-cols-4">
      {STATS.map((st, i) => (
        <Reveal key={st.label} delay={i * 0.08}>
          <div className="font-head text-4xl font-bold text-[hsl(var(--primary))] md:text-5xl">
            {st.value}
          </div>
          <div className="mt-2 text-sm text-[hsl(var(--muted))]">{st.label}</div>
        </Reveal>
      ))}
    </div>
  </section>
);
